import { onMounted, onUnmounted, ref } from 'vue';
import { useDebounceFn } from '@vueuse/core';

const useForceRender = () => {
  const refElement = ref<any>();
  const key = ref<number>(1);

  const debouncedFn = useDebounceFn(() => {
    key.value += 1;
  }, 500);

  onMounted(() => {
    window.addEventListener('resize', debouncedFn);
  });

  onUnmounted(() => {
    window.removeEventListener('resize', debouncedFn);
  });

  return {
    refElement,
    key,
  };
};

export default useForceRender;
